// extracted by mini-css-extract-plugin
export default {"file-step":"FileStep_file-step__oWbwJ","file-item-wrapper":"FileStep_file-item-wrapper__Xt-lG","file-form":"FileStep_file-form__yMXB1"};